module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon_fr-FR.546ad87d.jpg";